import { HttpClient, HttpParams } from '@angular/common/http';
import { CacheService } from '../cache';
import { ResourceService } from './resource';
import { Injectable } from '@angular/core';
import { Post } from '../../models/post';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BlogService extends ResourceService<Post> {
/**
   * @constructor 
   * Creates an instance of the BlogService 
   *
   * @param {HttpClient} http Injected instance of HttpClient
   * @param {CacheService} cache Injected instance of CacheService
  */
  constructor(
    protected http: HttpClient,
    protected cache: CacheService
  ) {
    super(http, cache, 'posts');
  }

  /**
  * Sends a GET request to the blog/posts endpoint of the typed Resource
  * @remarks
  *  to fetch and return copies of matching resource instances on the server
  *
  * @param {HttpParams} queryOptions Object representing fields or parameters to filter/query by
  * @param {boolean} raw: Optional flag
  * @returns {Observable} Returns an observable of array of typed Resources, with a server-side representations of the matching resources
  */
  public fetch(queryOptions?: HttpParams, raw?: boolean): Observable<Post[]> {
    return this.http.get<Post[]>(`blog/${this.endpoint}`, { params: queryOptions })
       .pipe(map((resp: any) => resp.data.posts));
  }

}
